// extracted by mini-css-extract-plugin
module.exports = {"container":"MessageCenter_container__23xGN","users":"MessageCenter_users__2sTIp","messages":"MessageCenter_messages__3VG2G","location":"MessageCenter_location__d5q-2"};